import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import { cnTextStyleModifierClassNames, cnThemeExtend } from './cn-theme.generated';
const twMerge = extendTailwindMerge({
    extend: {
        theme: cnThemeExtend,
        classGroups: {
            'focus-ring-dep': ['focus-ring-dep-thin', 'focus-ring-dep-thick'],
            'checkmark-color-dep': ['checkmark-black', 'checkmark-pink'],
            'text-style-modifier': [...cnTextStyleModifierClassNames],
        },
    },
});
/** Merges class names and resolves conflicting Tailwind utilities (the last one wins). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
